export { Input } from '@theme-ui/components';
export type { InputProps } from '@theme-ui/components';
